import {computed, makeObservable, observable} from "mobx";
import {JsonObject, JsonProperty} from "typescript-json-serializer";
import {AbstractModel} from "./abstract-model";

export interface ProjectPerimeterProps {
    objectId?: number;
    guid?: string;
    projectId?: number;
    creator?: string;
    createdAt?: Date;
    editor?: string;
    updatedAt?: Date;
}

/**
 * Project Perimeter (Fläche)
 * Polygon Feature
 */
@JsonObject()
export class ProjectPerimeter extends AbstractModel{

    static readonly comparableAttributes: string[] = [
        "guid", "id", "projectId", "objectType"
    ];
    // workaround, because feature template doesn't seem to work for table features
    static readonly prototypeAttributes: string[] = [
        "OBJECTID", "GUID", "PROJ_ID", "PERI_TYP",
        "CREATED_USER", "CREATED_AT", "UPDATED_USER", "UPDATED_AT"
    ];
    // field mappings
    static readonly databaseFieldNames: Map<string, string> = new Map<string, string>([
        ["objectId", "OBJECTID"],
        ["guid", "GUID"],
        ["projectId", "PROJ_ID"],
        ["objectType", "PERI_TYP"],
        ["creator", "CREATED_USER"],
        ["createdAt", "CREATED_AT"],
        ["editor", "UPDATED_USER"],
        ["updatedAt", "UPDATED_AT"]
    ]);

    class = "ProjectPerimeter";
    typeLabel = "Projektperimeter";


    /**
     * Unique identifier
     */
    @JsonProperty({name: "GUID"})
        guid: string;

    /**
     * Massnahme
     */
    @JsonProperty({name: "PROJ_ID"})
        projectId: number;

    /**
     * Objekttyp
     */
    @JsonProperty({name: "PERI_TYP"})
        objectType: number;


    constructor(props?: ProjectPerimeterProps) {
        super();
        if (props) {
            Object.assign(this, props);
        }
        // make observable after setting properties to avoid 'strict' messages
        makeObservable(this, {
            objectId: observable,
            guid: observable,
            projectId: observable,
            objectType: observable,

            isAlterable: computed,

            creator: observable,
            createdAt: observable,
            editor: observable,
            updatedAt: observable,
            isNewRecord: computed
        });
    }

    get comparableAttributes(): string[] {
        return ProjectPerimeter.comparableAttributes;
    }

    get isAlterable(): boolean {
        return true;
    }

}
